export const platformVersion = '^13.0.2';
